import { MarkdownContent } from "@components/design-system/atoms/MarkdownContent";
import { DSCardWrapper } from "@components/design-system/molecules";
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSpring, animated, config } from "@react-spring/web";
import { useState } from "react";

export default function HintCard({
  title,
  body,
  visible,
  dataTestId,
}) {
  const [lastContent, setLastContent] = useState({
    title: null,
    body: null,
  });

  // Cache the last non-null content so it stays visible while fading out
  if (
    (title || body) &&
    (title !== lastContent.title || body !== lastContent.body)
  ) {
    setLastContent({ title, body });
  }

  const shownTitle = title || lastContent.title;
  const shownBody = body || lastContent.body;

  const styles = useSpring({
    config: config.gentle,
    opacity: visible ? 1 : 0,
    transform: visible ? "translateX(0px)" : "translateX(-8px)",
  });

  if (!shownTitle && !shownBody) return null;

  return (
    <animated.div
      style={styles}
      role="status"
      aria-live="polite"
      aria-hidden={!visible}
    >
      <DSCardWrapper variant="info" dataTestId={dataTestId}>
        <div className="flex items-start gap-sm">
          <FontAwesomeIcon
            icon={faInfoCircle}
            className="text-brand mt-0.5 shrink-0"
          />
          <div>
            {shownTitle && (
              <h4 className="text-sm font-semibold text-primary mb-xs">
                {shownTitle}
              </h4>
            )}
            <MarkdownContent
              content={shownBody}
              className="text-xs text-secondary leading-relaxed"
            />
          </div>
        </div>
      </DSCardWrapper>
    </animated.div>
  );
}
